export default __webpack_public_path__ + "static/media/ic-triangle.77777915.svg";